import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { BFToSRIdMap, getPremiumIframe, setPremiumIframe, useAppDispatch, useAppSelector } from "@hypexone/uicore";
import Loader from "../../shared/Loader";
import MatchInfo from "./MatchInfo";

type RouteParams = {
  eventType: string;
  competition: string;
  eventId: string;
  eventInfo: string;
};

const VirtualMarket = () => {
  const { loading } = useAppSelector(state => state.auth);
  const { premiumIframe } = useAppSelector((state) => state.catalog);
  const routeParams = useParams<RouteParams>();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const {langData} = useAppSelector((state) => state.cms);

  const getGameUrl = async () => {
    const [sportId, competitionId, eventId] = atob(routeParams.eventInfo).split(":");

    const claims = sessionStorage?.getItem("jwt_token")?.split(".")[1];
    const userStatus = claims ? JSON.parse(window.atob(claims))?.status : 0;

    const sEventId = eventId.includes("_")
      ? eventId.split("_").join(":")
      : eventId;
    const sCompetitionId = competitionId?.includes("_")
      ? competitionId.split("_").join(":")
      : competitionId;

    if (userStatus === 0 || userStatus === 3) {
      return navigate(`/home`);
    }

    dispatch(
      getPremiumIframe({
        sportId: BFToSRIdMap[sportId] ?? sportId,
        competitionId: sCompetitionId,
        eventId: sEventId,
        navigate: navigate,
      })
    );
  };

  useEffect(() => {
    getGameUrl();

    return () => {
      dispatch(setPremiumIframe(""));
    };
  }, []);

  return (
    <div className="w-full h-full">
      {loading ? (
        <Loader />
      ) : (
        <div className="w-full h-[90vh] ">
          <div className="eam-info-header eam-info-header-name">
            <MatchInfo
              homeTeam={location?.state?.homeTeam}
              awayTeam={location?.state?.awayTeam}
              openDate={location?.state?.openDate}
            />
          </div>
          <iframe
            src={premiumIframe}
            title={langData?.['sportsbook']}
            allowFullScreen
            className="w-full h-full"
            sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default VirtualMarket;
